export default __webpack_public_path__ + "static/media/mixino.5bf68269.jpg";